import { forwardRef } from "react";

/* -----------------Types--------------- */
import type { SessionItem } from "@memorang/types/src/session/new-session";

import { Box } from "@memorang/ui";
/* -----------------Child components--------------- */
import SessionListDesktop from "./SessionListDesktop";

interface Props {
	items: SessionItem[];
	toggleShowReadMore: () => void;
}

// biome-ignore lint/suspicious/noExplicitAny: forwardRef typing compatibility
const SessionList = forwardRef<any, Props>(
	({ items, toggleShowReadMore }) => {
		return (
			<Box gap={16} flexGrow={1} height="100%">
				<SessionListDesktop
					items={items}
					toggleShowReadMore={toggleShowReadMore}
				/>
			</Box>
		);
	},
	// biome-ignore lint/suspicious/noExplicitAny: any cast required for export
) as any;
export default SessionList;
